export enum VoucherInputState {
  None,
  Prefilled,
  EnterVoucher,
  Loading,
  Invalid,
  Valid,
}

export interface DiscountCodeValidityResult {
  percent_off: number
}

export interface DiscountData {
  percent_off: number
  code: string
}

export type voucherValidateFn = (code: string) => Promise<DiscountData | null>
type validateSuccessCallback = (data: DiscountData) => void

export interface VoucherInputProps {
  prefilledData?: EF.DiscountInformation
  onReceiveDiscountInformation: validateSuccessCallback
  className?: string
}
